/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Severity levels for player errors.
 * Aligned with Shaka Player's shaka.util.Error.Severity values.
 */
export enum PlayerErrorSeverity {
  /**
   * The error is recoverable — playback can continue or retry automatically.
   */
  RECOVERABLE = 1,

  /**
   * The error is critical — playback cannot continue without intervention.
   */
  CRITICAL = 2
}
